import { Control, Controller, FieldErrors } from 'react-hook-form'

import { CSV_FORMATS } from '@/common/app/modules/csv'
import { masterTypeName } from '@/common/app/modules/master'
import { fileUploadPath } from '@/common/app/path'
import { MasterType } from '@/common/model/master/w2Master'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TextButton from '@/components/view/atoms/button/TextButton'
import SimpleTable from '@/components/view/atoms/table/SimpleTable'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import FormRow from '@/components/view/layouts/form/FormRow'
import Indent from '@/components/view/layouts/indent/Indent'

import { CsvUploadFormSchemaType } from '@/components/container/form/modules/master/csvUpload/csvUploadSchema'
import FormError from '@/components/container/form/widgets/FormError'
import FormFileUpload from '@/components/container/form/widgets/FormFileUpload'

interface Props {
  siteId: number
  masterType: MasterType
  control: Control<CsvUploadFormSchemaType>
  errors: FieldErrors<CsvUploadFormSchemaType>
}

const CsvUploadArea = ({ siteId, masterType, control, errors }: Props) => {
  const csvFormat = CSV_FORMATS.find((f) => f.type === masterType)

  return (
    <>
      <FormRow direction='vertical' gap={8} size={TextBoxSize.FULL}>
        <Text weight='bold'>{masterTypeName(masterType)}CSVファイルの追加</Text>
        <Controller
          name={'csv'}
          control={control}
          render={({ field: { value, onChange } }) => (
            <FormFileUpload
              onUploadFiles={(files) => {
                files.length > 0 && onChange(files[0])
              }}
              file={value}
              onDelete={() => onChange(undefined)}
            />
          )}
        />
        <FormError message={errors.csv?.message} />
      </FormRow>
      <FormRow direction='vertical' gap={4}>
        <FormRow justify='between'>
          <Text weight='bold' lineHeight={150}>
            CSVフォーマット
          </Text>
          <TextButton link={fileUploadPath(siteId)} newTab>
            詳細はこちら
          </TextButton>
        </FormRow>
        <Indent full>
          {csvFormat && (
            <SimpleTable>
              <thead>
                <TableRow head noBorder>
                  <TableHeadItem type='thin'>
                    <Text size={12} weight='bold' color={TextColor.SECONDARY}>
                      カラム名
                    </Text>
                  </TableHeadItem>
                  <TableHeadItem type='thin'>
                    <Text size={12} weight='bold' color={TextColor.SECONDARY}>
                      必須
                    </Text>
                  </TableHeadItem>
                  <TableHeadItem type='thin'>
                    <Text size={12} weight='bold' color={TextColor.SECONDARY}>
                      説明
                    </Text>
                  </TableHeadItem>
                </TableRow>
              </thead>
              <tbody>
                {csvFormat.columns.map((col) => (
                  <TableRow key={col.name}>
                    <TableRowItem width={160} type='low'>
                      <Text size={12}>{col.name}</Text>
                    </TableRowItem>
                    <TableRowItem width={64} type='low'>
                      <Badge
                        size={10}
                        badgeType={col.required ? BadgeType.SUCCESS : BadgeType.SECONDARY}
                      >
                        {col.required ? '必須' : '任意'}
                      </Badge>
                    </TableRowItem>
                    <TableRowItem type='low'>
                      <Text size={12}>{col.desc}</Text>
                    </TableRowItem>
                  </TableRow>
                ))}
              </tbody>
            </SimpleTable>
          )}
        </Indent>
      </FormRow>
    </>
  )
}

export default CsvUploadArea
